import { isTestEnv } from '@/utils/env'

export const devLog = (...args) => isTestEnv && console.log(...args)

export default 0
